export default "__VITE_ASSET__CnaQhmge__"